import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.77967 21.1278L6.54463 15.8518L9.40024 18.6618L7.53177 21.2978L1.77967 21.1278Z"
        fill={colorValue}
      />
      <path
        d="M12.0586 21.3317L9.40103 18.6507L12.7394 14.7288L19.1723 21.1277L12.0586 21.3317Z"
        fill={colorValue}
      />
      <path
        d="M9.44036 18.7182L1 10.2778L8.40261 10.0705L9.78624 11.6617L17.3963 2.66797L23 2.80634L9.44036 18.7182Z"
        fill={colorValue}
      />
    </svg>
  );
};
